export default "__VITE_ASSET__NKk0_q48__"